import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import NewSupplier from "../models/NewSupplier";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import AddMedicine from "../models/AddMedicine";

function NewPurchase() {
    const navigate = useNavigate();
    const [ldata, setLdata] = useState(null);
    const [supplierSearch, setSupplierSearch] = useState("");
    const [showSupplierOptions, setShowSupplierOptions] = useState(false);
    const [medicineSearch, setMedicineSearch] = useState("");
    const [showMedicineOptions, setShowMedicineOptions] = useState(false);
    const wrapperRef = useRef(null);
    const [newlyAddedSupplier, setNewlyAddedSupplier] = useState(null);
    const medicineSelectRef = useRef(null);
    const [activeCell, setActiveCell] = useState(null);
    const [isMedicineMenuOpen, setIsMedicineMenuOpen] = useState(false);

    const [formData, setFormData] = useState({
        medicines: [],
        l1: [],
        medicineList: [],
        purchase_id: '',
        purchase_type: 'normal',
        purchase_challan: '',
        purchase_invoice: '',
        purchase_date: '',
        purchase_supplier: '',
        purchase_total: '',
        purchase_paid: '',
        purchase_due: '',
        purchase_user: '',
        
        other_charges: '0',
        discount_on_all_type: 'Per%',
        discount_on_all_value: '0',
        note: '',
        
        total_quantities: 0,
        subtotal: '0.00',
        total_gst: '0.00',
        discount_on_all_amount: '0.00',
        grand_total: '0.00',

        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
    
    const [selectedMedicine, setSelectedMedicine] = useState(null);
const [originalRecord, setOriginalRecord] = useState(null);   // ✅ ADD

    const supplierOptions = formData.l1
        ?.filter(s => s.type === "supplier")
        .map(s => ({
            value: s.fname,
            label: `${s.fname} (${s.mobile})`,
            raw: s
        }));
    
    const medicineOptions = formData.medicineList?.map(m => ({
        value: m.med_name,
        label: `HSN-${m.med_hsn_code} - ${m.med_name}`,
        raw: m
    }));
    

    const attachUserInfo = (fd) => {
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('user_id',   u.user_id   || '');
            fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
            fd.append('user_role', u.role_id   || u.role_name || '');
          }
        } catch (e) {
          console.warn("attachUserInfo failed:", e);
        }
        return fd;
    };
    
    const handleCancel = () => {
        sessionStorage.removeItem("opd_dt");
        navigate("/purchases");
    };

    
    const handleDeleteItem = async (index) => {
        const item = formData.medicines[index];
    
        // ✅ UNSAVED ITEM (NO DB ID)
        if (!item.purchase_item_id) {
            const tmp = [...formData.medicines];
            tmp.splice(index, 1);
            setFormData(prev => ({ ...prev, medicines: tmp }));
            return;
        }
    
        // ✅ SAVED ITEM → CALL BACKEND
        try {
            const fd = new FormData();
            fd.append('purchase_item_id', item.purchase_item_id);
    
            const res = await axios.post(
                AppConst.BASE_URL + AppConst.deletePurchaseItemUrl,
                fd
            );
    
            if (res.data.status) {
                toast.success(res.data.message);
                const tmp = [...formData.medicines];
                tmp.splice(index, 1);
                setFormData(prev => ({ ...prev, medicines: tmp }));
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error("Delete failed");
        }
    };
      
    const handleAddMedicine = () => {
        initData3();
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") === 0) {
            initData();
        }
    };

    const handleChange1 = (e, index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");
    
        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            
            let currentItem = {
                ...updatedItems[index],
                [name1]: value
            };
    
            // ✅ GET VALUES
            const qty = parseFloat(currentItem.purchase_item_qty) || 0;
            const price = parseFloat(currentItem.purchase_item_pur_price) || 0;
            const discountPercent = parseFloat(currentItem.purchase_item_discount) || 0;
            const gstPercent = parseFloat(currentItem.purchase_item_gst) || 0;
    
            // ✅ CALCULATE PER UNIT
            const priceAfterDiscount = price - (price * (discountPercent / 100));
            const gstPerUnit = priceAfterDiscount * (gstPercent / 100);
            
            // ✅ TOTAL = QTY × PURCHASE RATE (AFTER DISCOUNT)
            const totalAmount = priceAfterDiscount * qty;
    
            // ✅ UPDATE CALCULATED FIELDS
            currentItem.purchase_item_gross_value = priceAfterDiscount.toFixed(2);
            currentItem.purchase_item_gst_value = gstPerUnit.toFixed(3);
            currentItem.purchase_item_gtotal = totalAmount.toFixed(2);
            
            updatedItems[index] = currentItem;
    
            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };

    const handleCellClick = (rowIndex, cellName, e) => {
        if (e?.target.closest('.text-danger')) {
            return;
        }
        setActiveCell({ rowIndex, cellName });
    };

    const isCellActive = (rowIndex, cellName) => {
        return activeCell && activeCell.rowIndex === rowIndex && activeCell.cellName === cellName;
    };



    
    // Focus on input when cell becomes active
    useEffect(() => {
        if (activeCell) {
            const input = document.querySelector(`input[name="${activeCell.cellName}${activeCell.rowIndex}"]`);
            if (input) {
                input.focus();
                input.select();
            }
        }
    }, [activeCell]);

    // Keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Tab" && activeCell !== null) {
                e.preventDefault();
                setActiveCell(null);
            }

            if (e.key === "Enter" && !e.ctrlKey && activeCell === null) {
                e.preventDefault();
                setIsMedicineMenuOpen(true);
            }

            if (e.key === "Escape" && activeCell !== null) {
                e.preventDefault();
                setActiveCell(null);
            }

            if (e.ctrlKey && e.key.toLowerCase() === "s") {
                e.preventDefault();
                document.getElementById("savePurchaseBtn")?.click();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [activeCell]);
    
    // ✅ RECALCULATE TOTALS WHEN ITEMS OR CHARGES CHANGE
    useEffect(() => {
        const { medicines, other_charges, discount_on_all_value, discount_on_all_type } = formData;
    
        // Sum up all item totals
        const subtotal = medicines.reduce((sum, item) => {
            return sum + (parseFloat(item.purchase_item_gtotal) || 0);
        }, 0);
    
        // Sum up all GST amounts
        const totalGst = medicines.reduce((sum, item) => {
            const qty = parseFloat(item.purchase_item_qty) || 0;
            const gstPerUnit = parseFloat(item.purchase_item_gst_value) || 0;
            return sum + (gstPerUnit * qty);
        }, 0);
    
        // Total quantities (Qty + Free)
        const totalQuantities = medicines.reduce((sum, item) => {
            return sum + (parseFloat(item.purchase_item_qty) || 0) + (parseFloat(item.purchase_item_free) || 0);
        }, 0);
    
        const otherChargesValue = parseFloat(other_charges) || 0;
        const baseForDiscount = subtotal + otherChargesValue;
        
        let discountAmount = 0;
        const discountInput = parseFloat(discount_on_all_value) || 0;
        
        if (discount_on_all_type === 'Per%') {
            discountAmount = (baseForDiscount * discountInput) / 100;
        } else {
            discountAmount = discountInput;
        }
    
        const finalTotal = baseForDiscount - discountAmount + totalGst;
    
        setFormData(prev => ({
            ...prev,
            total_quantities: totalQuantities,
            subtotal: subtotal.toFixed(2),
            total_gst: totalGst.toFixed(2),
            discount_on_all_amount: discountAmount.toFixed(2),
            grand_total: finalTotal.toFixed(2),
            purchase_total: finalTotal.toFixed(2)
        }));
    
    }, [formData.medicines, formData.other_charges, formData.discount_on_all_value, formData.discount_on_all_type]);
    
    // ✅ UPDATE DUE AMOUNT
    useEffect(() => {
        const total = parseFloat(formData.purchase_total) || 0;
        const paid = parseFloat(formData.purchase_paid) || 0;
        setFormData(prev => ({
            ...prev,
            purchase_due: (total - paid).toFixed(2)
        }));
    }, [formData.purchase_total, formData.purchase_paid]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.purchase_supplier) {
            toast.error("Please select a supplier");
            return;
        }
        
        if (formData.medicines.length === 0) {
            toast.error("Please add at least one medicine");
            return;
        }
        
        // ✅ Validate expiry dates
        const currentYear = new Date().getFullYear() % 100;
        for (let i = 0; i < formData.medicines.length; i++) {
            const item = formData.medicines[i];
            const month = parseInt(item.purchase_item_expiry_month);
            const year = parseInt(item.purchase_item_expiry_year);
        
            if (month < 1 || month > 12) {
                toast.error(`${item.purchase_item_medicine}: Expiry month must be between 1-12`);
                return;
            }
            if (year < currentYear) {
                toast.error(`${item.purchase_item_medicine}: Expiry year (${year}) is in the past. Must be ${currentYear} or later`);
                return;
            }
        }
        
        const fd = new FormData();
        
        
        fd.append('purchase_id', formData.purchase_id);
        fd.append('purchase_type', formData.purchase_type);
        fd.append('purchase_challan', formData.purchase_challan);
        fd.append('purchase_invoice', formData.purchase_invoice);
        fd.append('purchase_date', formData.purchase_date);
        fd.append('purchase_supplier', formData.purchase_supplier);
        fd.append('purchase_total', formData.grand_total);
        fd.append('purchase_paid', formData.purchase_paid || 0);
        fd.append('purchase_due', formData.purchase_due);
        fd.append('purchase_items', JSON.stringify(formData.medicines));
        fd.append('purchase_user', ldata.user_id);
        fd.append('other_charges', formData.other_charges);
        fd.append('discount_on_all_type', formData.discount_on_all_type);
        fd.append('discount_on_all_value', formData.discount_on_all_value);
        fd.append('discount_on_all_amount', formData.discount_on_all_amount);
        fd.append('note', formData.note ?? '');
    
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addPurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.data.status) {
                // ✅ AUDIT LOG: If this was an EDIT (not new), log it
                if (formData.purchase_id && originalRecord) {
                    try {
                        const logFd = new FormData();
                        logFd.append('record_id', formData.purchase_id);
                        logFd.append('old_data', JSON.stringify(originalRecord));
                        logFd.append('remarks', 'Purchase record updated');
                        attachUserInfo(logFd);
                        
                        await axios.post(
                            AppConst.BASE_URL + AppConst.logEditPurchaseUrl,
                            logFd,
                            { headers: { 'Content-Type': 'multipart/form-data' } }
                        );
                        console.log("✅ Purchase edit logged");
                    } catch (logErr) {
                        console.warn("⚠️ Audit log failed (non-critical):", logErr);
                    }
                }
            
                sessionStorage.removeItem("opd_dt");
                toast.success(response.data.success || "Purchase saved successfully");
                navigate("/purchases");
            } else {
                toast.error(response.data.success || "Failed to save purchase");
            }
        } catch (error) {
            console.error("Purchase save error:", error);
            toast.error("An error occurred while saving the purchase");
        }
    };
    
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records !== undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items?.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }
    
            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records !== undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "supplier");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records !== undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                        
                        if (newlyAddedSupplier) {
                            const addedSupplier = records.find(s => s.fname === newlyAddedSupplier);
                            if (addedSupplier) {
                                handleSupplierSelect(addedSupplier);
                                setNewlyAddedSupplier(null);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const initData3 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getMedListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records !== undefined) {
                        setFormData(prev => ({
                            ...prev,
                            medicineList: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    
    // ✅ COMPONENT MOUNT & LOAD EDIT DATA
    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
            initData3();
        }
    
        // ✅ Check if editing existing purchase
        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") !== undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            console.log("Edit Data : " + JSON.stringify(tmp));
            
            if (tmp != null && tmp !== undefined) {
                setOriginalRecord(tmp);
                var items = tmp.items;
                setFormData(prev => ({
                    ...prev,
                    medicines: items || [],
                    purchase_id: tmp.purchase_id || '',
                    purchase_challan: tmp.purchase_challan || '',
                    purchase_type: tmp.purchase_type || 'normal',
                    purchase_invoice: tmp.purchase_invoice || '',
                    purchase_date: tmp.purchase_date || '',
                    purchase_supplier: tmp.purchase_supplier || '',
                    purchase_total: tmp.purchase_total || '',
                    purchase_paid: tmp.purchase_paid || '0',
                    purchase_due: tmp.purchase_due || '',
                    // ✅ CRITICAL: Load discount and charges fields
                    other_charges: tmp.other_charges || '0',
                    discount_on_all_type: tmp.discount_on_all_type || 'Per%',
                    discount_on_all_value: tmp.discount_on_all_value || '0',
                    discount_on_all_amount: tmp.discount_on_all_amount || '0',
                    note: tmp.note || '',
                }));
                setSupplierSearch(tmp.purchase_supplier || "");
            }
        } else {
            // ✅ If NOT editing (new purchase), set current date
            const today = new Date();
            const formatted = today.toISOString().split('T')[0];
            setFormData(prev => ({
                ...prev,
                purchase_date: formatted
            }));
        }
    
        return () => {
            // Cleanup
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddDepart = (newSupplierName) => {
        formData.page_no = 0;
        if (newSupplierName) {
            setNewlyAddedSupplier(newSupplierName);
        }
        initData2();
    };

    const handleSupplierSelect = (supplier) => {
        setFormData((prev) => ({
            ...prev,
            purchase_supplier: supplier.fname,
        }));
        setSupplierSearch(supplier.fname);
        setShowSupplierOptions(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSupplierOptions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);
    
    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>Pharmacy Purchase</h5>
                                <br />
                                
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <label className="form-label">Supplier *</label>
                                                <div className="d-flex gap-2">
                                                    <div style={{ flex: 1 }}>
                                                        <Select
                                                            className={!formData.purchase_supplier ? "is-invalid" : ""}
                                                            options={supplierOptions}
                                                            placeholder="Search Supplier..."
                                                            value={supplierOptions?.find(o => o.value === formData.purchase_supplier) || null}
                                                            onChange={(opt) => {
                                                                setFormData(prev => ({ ...prev, purchase_supplier: opt ? opt.value : "" }));
                                                            }}
                                                            isClearable
                                                        />
                                                        {!formData.purchase_supplier && (
                                                            <div className="invalid-feedback d-block">Please select a supplier.</div>
                                                        )}
                                                    </div>
                                                    
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-outline-primary" 
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#showModal"
                                                        style={{ height: '38px' }}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-md-2"></div>
                                            
                                            <div className="col-md-4">
                                                <div>
                                                    <label htmlFor="purchase_invoice" className="form-label">Invoice *</label>
                                                    <input 
                                                        name="purchase_invoice" 
                                                        onChange={handleChange} 
                                                        value={formData.purchase_invoice} 
                                                        className="form-control" 
                                                        placeholder="Enter Invoice" 
                                                        type="text" 
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-5">
                                                <br/>
                                                <div>
                                                    <label htmlFor="purchase_date" className="form-label">Purchase Date *</label>
                                                    <input 
                                                        name="purchase_date" 
                                                        onChange={handleChange} 
                                                        value={formData.purchase_date} 
                                                        className="form-control" 
                                                        placeholder="Enter Date" 
                                                        type="date" 
                                                        required 
                                                        readOnly={!!formData.purchase_id}
                                                        style={formData.purchase_id ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                                                    />
                                                    {formData.purchase_id && (
                                                        <small className="text-muted">Purchase date cannot be changed when editing</small>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-2"></div>
                                            
                                            <div className="col-md-4">
                                                <br />
                                                <div>
                                                    <label htmlFor="purchase_challan" className="form-label">Bill No / Challan No</label>
                                                    <input 
                                                        name="purchase_challan"
                                                        onChange={handleChange} 
                                                        value={formData.purchase_challan}
                                                        className="form-control" 
                                                        placeholder="Enter Bill or Challan No"
                                                        type="text" 
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-12">
                                                <br /><br />
                                            </div>

                                            <div className="col-lg-12">
                                                <br />
                                                <div className="row mb-3">
                                                    <div className="col-2"></div>
                                                    <div className="col-xxl-8 col-sm-8">
                                                        <div className="custom-search-box d-flex align-items-center gap-2">
                                                            <span className="search-icon-box">
                                                                <i className="ri-barcode-line"></i>
                                                            </span>

                                                            <div style={{ flex: 1 }}>
                                                                <Select
                                                                    ref={medicineSelectRef}
                                                                    options={medicineOptions}
                                                                    placeholder="Item name / Barcode / Item code"
                                                                    value={selectedMedicine}
                                                                    menuIsOpen={isMedicineMenuOpen}
                                                                    onMenuOpen={() => setIsMedicineMenuOpen(true)}
                                                                    onMenuClose={() => setIsMedicineMenuOpen(false)}
                                                                    openMenuOnFocus
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    onChange={(opt) => {
                                                                        if (!opt) return;
                                                                        const m = opt.raw;

                                                                        setFormData(prev => {
                                                                            return {
                                                                                ...prev,
                                                                                medicines: [
                                                                                    ...prev.medicines,
                                                                                    {
                                                                                        purchase_item_medicine: m.med_name,
                                                                                        purchase_item_medicine_id: m.med_id,
                                                                                        purchase_item_hsn: m.med_hsn_code || "30049069",
                                                                                        purchase_item_qty: "1",
                                                                                        purchase_item_tab_cap: m.med_in_strips,
                                                                                        purchase_item_free: "0",
                                                                                        purchase_item_batch: "",
                                                                                        purchase_item_expiry_month: "",
                                                                                        purchase_item_expiry_year: "",
                                                                                        purchase_item_pur_price: "",
                                                                                        purchase_item_mrp: "",
                                                                                        purchase_item_discount: "0.00",
                                                                                        purchase_item_gst: m.med_gst || m.med_comp_name || 0,
                                                                                        purchase_item_gst_value: "0.00",
                                                                                        purchase_item_gross_value: "0.00",
                                                                                        purchase_item_gtotal: "0.00",
                                                                                    }
                                                                                ]
                                                                            };
                                                                        });

                                                                        setSelectedMedicine(null);
                                                                        setIsMedicineMenuOpen(false);
                                                                    }}
                                                                    isClearable
                                                                />
                                                            </div>

                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#addMedicineModal"
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                        <div
                                                            className="mt-2"
                                                            style={{
                                                                color: "#0d3b66",
                                                                fontSize: "13px",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            <span className="me-3">
                                                                ⌨️ <strong>Enter</strong> : Open Medicine Search
                                                            </span>
                                                            <span className="me-3">
                                                                ⌨️ <strong>Tab/ESC</strong> : Deactivate Cell
                                                            </span>
                                                            <span className="me-3">
                                                                ⌨️ <strong>Ctrl + S</strong> : Save Purchase
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-2"></div>
                                                </div>
                                                
                                                <div className="row">
                                                    <div className="col-lg-8">
                                                        <h6>Medicines</h6>
                                                    </div>
                                                    <div className="col-lg-4" style={{ textAlign: "right" }}></div>
                                                </div>
                                                <br />
                                            </div>
                                            
                                            <div className="col-md-12">
                                                <div className="card-body pt-0">
                                                    <div>
                                                        <div className="table-responsive table-card mb-1" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                                            <table
                                                                className="table table-nowrap align-middle"
                                                                id="orderTable"
                                                                style={{ minWidth: "1400px" }}
                                                            >
                                                                <thead className="text-muted table-light">
                                                                    <tr className="text-uppercase">
                                                                        <th style={{ minWidth: '100px' }}>Medicine</th>
                                                                        <th style={{ width: '80px' }}>HSN</th>
                                                                        <th style={{ width: '80px' }}>Qty</th>
                                                                        <th style={{ width: '80px' }}>Strips</th>
                                                                        <th style={{ width: '80px' }}>Free</th>
                                                                        <th style={{ width: '100px' }}>Batch</th>
                                                                        <th style={{ width: '120px' }}>Expiry</th>
                                                                        <th style={{ width: '90px' }}>P. Rate</th>
                                                                        <th style={{ width: '90px' }}>MRP</th>
                                                                        <th style={{ width: '80px' }}>Disc%</th>
                                                                        <th style={{ width: '80px' }}>GST%</th>
                                                                        <th style={{ width: '90px' }}>Tax</th>
                                                                        <th style={{ width: '90px' }}>Gross</th>
                                                                        <th style={{ width: '90px' }}>Total</th>
                                                                        <th style={{ width: '60px' }}>Act</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="list form-check-all">
                                                                    {formData.medicines.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td style={{ minWidth: '100px' }} onClick={(e) => handleCellClick(index, 'purchase_item_medicine', e)}>
                                                                                <input 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_medicine'+index} 
                                                                                    value={item.purchase_item_medicine} 
                                                                                    readOnly 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_medicine') ? '#fff' : '#e9ecef',
                                                                                        cursor: 'not-allowed'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            
                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_hsn', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_hsn'+index} 
                                                                                    value={item.purchase_item_hsn} 
                                                                                    onChange={(e) => handleChange1(e, index)} 
                                                                                    placeholder="HSN" 
                                                                                    readOnly
                                                                                    style={{
                                                                                        backgroundColor: '#e9ecef',
                                                                                        cursor: 'not-allowed'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            
                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_qty', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_qty'+index} 
                                                                                    value={item.purchase_item_qty} 
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_qty') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_tab_cap', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_tab_cap'+index} 
                                                                                    value={item.purchase_item_tab_cap} 
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_tab_cap') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_free', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_free'+index} 
                                                                                    value={item.purchase_item_free} 
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_free') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '100px' }} onClick={(e) => handleCellClick(index, 'purchase_item_batch', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_batch'+index} 
                                                                                    value={item.purchase_item_batch} 
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    required
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_batch') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '120px' }} onClick={(e) => handleCellClick(index, 'purchase_item_expiry', e)}>
    <div className="d-flex gap-1">
        <input
            type="text"
            className="form-control"
            placeholder="MM"
            name={'purchase_item_expiry_month'+index}
            value={item.purchase_item_expiry_month || ""}
            required
            maxLength={2}
            onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, '');
                const num = parseInt(val);
                if (val === '' || (num >= 0 && num <= 12)) {
                    handleChange1({ target: { name: e.target.name, value: val } }, index);
                }
                if (num > 12) {
                    toast.error("Month cannot be more than 12");
                }
            }}
            onBlur={(e) => {
                const val = parseInt(e.target.value);
                if (val === 0) {
                    toast.error("Month cannot be 0");
                    handleChange1({ target: { name: e.target.name, value: '' } }, index);
                }
            }}
            style={{
                backgroundColor: isCellActive(index, 'purchase_item_expiry') ? '#fff' : '#f8f9fa'
            }}
        />
        <input
            type="text"
            className="form-control"
            placeholder="YY"
            name={'purchase_item_expiry_year'+index}
            value={item.purchase_item_expiry_year || ""}
            required
            maxLength={2}
            onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, '');
                handleChange1({ target: { name: e.target.name, value: val } }, index);
            }}
            onBlur={(e) => {
                const val = parseInt(e.target.value);
                const currentYear = new Date().getFullYear() % 100;
                if (val && val < currentYear) {
                    toast.error(`Expiry year must be ${currentYear} or later. You entered ${val}`);
                    handleChange1({ target: { name: e.target.name, value: '' } }, index);
                }
            }}
            style={{
                backgroundColor: isCellActive(index, 'purchase_item_expiry') ? '#fff' : '#f8f9fa'
            }}
        />
    </div>
</td>
                                                                            <td style={{ width: '90px' }} onClick={(e) => handleCellClick(index, 'purchase_item_pur_price', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_pur_price'+index} 
                                                                                    value={item.purchase_item_pur_price} 
                                                                                    required
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_pur_price') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            
                                                                            <td style={{ width: '90px' }} onClick={(e) => handleCellClick(index, 'purchase_item_mrp', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_mrp'+index} 
                                                                                    value={item.purchase_item_mrp} 
                                                                                    required
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_mrp') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_discount', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_discount'+index} 
                                                                                    value={item.purchase_item_discount} 
                                                                                    onChange={(e) => handleChange1(e,index)} 
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_discount') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '80px' }} onClick={(e) => handleCellClick(index, 'purchase_item_gst', e)}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_gst' + index}
                                                                                    value={item.purchase_item_gst}
                                                                                    onChange={(e) => handleChange1(e,index)}
                                                                                    placeholder="0"
                                                                                    style={{
                                                                                        backgroundColor: isCellActive(index, 'purchase_item_gst') ? '#fff' : '#f8f9fa'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '90px' }}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_gst_value' + index}
                                                                                    value={item.purchase_item_gst_value}
                                                                                    readOnly
                                                                                    placeholder="0.00" 
                                                                                    style={{
                                                                                        backgroundColor: '#e9ecef',
                                                                                        cursor: 'not-allowed'
                                                                                    }}
                                                                                />
                                                                            </td>

                                                                            <td style={{ width: '90px' }}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_gross_value' + index}
                                                                                    value={item.purchase_item_gross_value}
                                                                                    readOnly
                                                                                    style={{
                                                                                        backgroundColor: '#e9ecef',
                                                                                        cursor: 'not-allowed'
                                                                                    }}
                                                                               />
                                                                            </td>
                                                                            
                                                                            <td style={{ width: '90px' }}>
                                                                                <input 
                                                                                    type="text" 
                                                                                    className="form-control" 
                                                                                    name={'purchase_item_gtotal' + index}
                                                                                    value={item.purchase_item_gtotal}
                                                                                    readOnly
                                                                                    style={{
                                                                                        backgroundColor: '#e9ecef',
                                                                                        cursor: 'not-allowed'
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                          
                                                                            <td style={{ width: '60px', textAlign: 'center', padding: '8px' }}>
    <span
        className="text-danger d-inline-block"
        tabIndex={-1}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleDeleteItem(index);
        }}
        style={{ cursor: 'pointer' }}
        role="button"
    >
        <i className="ri-delete-bin-5-fill fs-16"></i>
    </span>
</td>

                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-4">
                                                <div className="col-lg-8">
                                                    <div className="row g-3">
                                                        <div className="col-md-4">
                                                            <label>Total Quantities</label>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                value={formData.total_quantities} 
                                                                readOnly 
                                                            />
                                                        </div>
                                                        <div className="col-md-8">
                                                            <label htmlFor="other_charges">Other Charges</label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="number"
                                                                    id="other_charges"
                                                                    className="form-control"
                                                                    name="other_charges"
                                                                    value={formData.other_charges}
                                                                    onChange={handleChange}
                                                                />
                                                                <span className="input-group-text">₹</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label htmlFor="discount_on_all_value">Discount on All</label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="number"
                                                                    id="discount_on_all_value"
                                                                    className="form-control"
                                                                    name="discount_on_all_value"
                                                                    value={formData.discount_on_all_value}
                                                                    onChange={handleChange}
                                                                />
                                                                <select 
                                                                    className="form-select" 
                                                                    style={{maxWidth: '100px'}}
                                                                    name="discount_on_all_type"
                                                                    value={formData.discount_on_all_type}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="Per%">Per(%)</option>
                                                                    <option value="Flat">Flat(₹)</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label htmlFor="note">Note</label>
                                                            <textarea 
                                                                id="note"
                                                                className="form-control" 
                                                                rows="3"
                                                                name="note"
                                                                value={formData.note}
                                                                onChange={handleChange}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Subtotal</span>
                                                                <span>₹ {formData.subtotal}</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Other Charges</span>
                                                                <span>₹ {parseFloat(formData.other_charges || 0).toFixed(2)}</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Total GST</span>
                                                                <span>₹ {formData.total_gst}</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-2 text-danger">
                                                                <span>Discount on All</span>
                                                                <span>- ₹ {formData.discount_on_all_amount}</span>
                                                            </div>
                                                            <hr />
                                                            <div className="d-flex justify-content-between h5">
                                                                <strong>Grand Total</strong>
                                                                <strong>₹ {formData.grand_total}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="d-flex justify-content-end gap-2">
                                                <button type="submit" id="savePurchaseBtn" className="btn btn-primary">
                                                    Save
                                                </button>
                                                <button type="button" className="btn btn-danger" onClick={handleCancel}>
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <NewSupplier onAddDepart={handleAddDepart} />
                                <AddMedicine onAddDepart={handleAddMedicine} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewPurchase;